import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter } from '@cmg/data-grid';

import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';

export const valueFormatter = createValueFormatter<
  FirmInvestorContactsGridItemFragment,
  FirmInvestorContactsGridItemFragment['source']
>();

export const sourceColDef: ServerColDef<FirmInvestorContactsGridItemFragment> = {
  field: 'source',
  headerName: 'Source',
  valueFormatter,
};
